
<div class="warp-tooltip" *ngIf="isUnauthorized$() && isFilterField">
  <div class="filter-field" >
    <img src="/assets/images/selected-filter.svg" />
    <!-- <span translate>filterField.filterField</span> -->
  </div>
  <div class="tooltip-abs">
    <p translate>filterField.filterFieldTooltip</p>
  </div>
</div>
